import { useEffect } from 'react'

import { mbonusApi } from 'redux/services/mbonus'
import { GetMBonusParams } from 'redux/services/mbonus/types'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

interface StatisticsProps {
  filters: GetMBonusParams
}

export function Statistics({ filters }: StatisticsProps) {
  const [fetch, fetchState] = mbonusApi.useLazyMbonusStatisticsQuery()

  useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  if (fetchState.isSuccess) {
    return <AppStatistics list={fetchState.data} />
  }
  return null
}
